function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.9,8.7c-9-1.6-17.6,4.5-19.2,13.5s4.5,17.6,13.5,19.2c9,1.6,17.6-4.5,19.2-13.5C42.9,18.9,36.9,10.3,27.9,8.7z  M27.6,10.1c8.2,1.4,13.8,9.3,12.2,17.5s-9.3,13.8-17.5,12.2c-8.2-1.4-13.8-9.3-12.2-17.5S19.4,8.7,27.6,10.1z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 24.3,
  y: 9.9,
  transform: "matrix(0.1712 -0.9852 0.9852 0.1712 -3.923 45.336)",
  width: 1.4,
  height: 30.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 15.4,
  transform: "matrix(0.1742 -0.9847 0.9847 0.1742 0.7597 42.4698)",
  width: 1.4,
  height: 10.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 23.5,
  y: 23.9,
  transform: "matrix(0.1742 -0.9847 0.9847 0.1742 -8.8544 47.9946)",
  width: 1.4,
  height: 10.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 25.7,
  y: 8.6,
  transform: "matrix(0.1732 -0.9849 0.9849 0.1732 5.6315 39.7045)",
  width: 1.4,
  height: 15.8
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 22.7,
  y: 25.6,
  transform: "matrix(0.1732 -0.9849 0.9849 0.1732 -13.6044 50.7758)",
  width: 1.4,
  height: 15.8
})));

function SvgAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.3a544f61.svg";
export { ForwardRef as ReactComponent };